import { useApplication } from '@/hooks/useApplication';
import { useMetadataBlock } from '@/hooks/useMetadataBlock';
import { Connection } from '@/types/connection';
import { updateConnection } from '@/util/application';
import { queueUtil } from '@/util/validation/queue';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { FC } from 'react';
import { ParamProps } from './ParamRenderer';

const ParamQueue: FC<ParamProps> = (props) => {
  const { application, setApplication } = useApplication();
  const { metadataBlock } = useMetadataBlock();

  const initialValue = queueUtil().getValue(props.configuration, props.initialValue);

  const type = metadataBlock?.output_ports[application.blocks.portoptions[props.nodeId]?.index || 0]?.type || 'fixed';

  const handleChange = (e: SelectChangeEvent<any>) => {
    if (type !== 'fixed') {
      const newMessages =
        application.queues
          ?.find((queue) => queue.queue === e.target.value)
          ?.messages.map((message, index) => ({
            action: message,
            label: '',
            dst: null,
            id: index + 1
          })) || [];

      const metadataPorts: Connection[] = [];
      metadataBlock?.output_ports
        .filter((outputPort) => outputPort.type === 'queue')
        ?.forEach((metaPorts) =>
          metaPorts.ports.forEach((port, index) => {
            metadataPorts.push({
              action: port.action,
              label: port.label,
              dst: null,
              id: newMessages.length + index + 1
            });
          })
        );

      setApplication((previous) =>
        updateConnection(props.nodeId.toString(), [...newMessages, ...metadataPorts], previous)
      );
    }

    props.onChange([props.configuration.value, e.target.value]);
  };

  return (
    <FormControl fullWidth size='small' required={props.configuration.required}>
      <InputLabel id='select-queue-label'>{props.configuration.label}</InputLabel>
      <Select
        labelId='select-queue-label'
        id='select-queue'
        value={initialValue || ''}
        label={props.configuration.label}
        onChange={handleChange}
        required={props.configuration.required}
        error={!!props.errors?.length}
      >
        {application.queues?.map((queue) => (
          <MenuItem value={queue.queue}>{queue.queue}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
export default ParamQueue;
